<template>
  <div class="course_list" ref="top">
    <CourseFilter
      :courses="course"
      :freeCourses.sync="filterFreeCourses"
      :bath.sync="filterBath"
      :category.sync="filterCategory"
      :categories="categories"
      :baths="baths"
    ></CourseFilter>
    <Divider></Divider>
    <CourseListing
      :items="filteredCourses"
      :settings="settings"
    ></CourseListing>
  </div>
</template>

<script>
import axios from "axios";
import CourseFilter from "@/components/CourseFilter";
import CourseListing from "@/components/CourseListing.vue";
import Divider from "@/components/Divider.vue";

export default {
  name: "CourseList",
  components: { Divider, CourseListing, CourseFilter },
  props: ["settings"],
  data() {
    return {
      course: [],
      currentPage: 1,
      items: 10,
      weekdays: [
        { dow: 1, text: "MO" },
        { dow: 2, text: "DI" },
        { dow: 3, text: "MI" },
        { dow: 4, text: "DO" },
        { dow: 5, text: "FR" },
        { dow: 6, text: "SA" },
        { dow: 0, text: "SO" }
      ],
      filterFreeCourses: false,
      filterBath: "",
      filterCategory: "",
      filterName: "",
      categories: [],
      baths: []
    };
  },
  computed: {
    filteredCourses: function() {
      if (this.course === undefined) return [];
      let courses = this.course;
      if (this.filterBath !== "")
        courses = courses.filter(item => item.location === this.filterBath);
      if (this.filterCategory !== "")
        courses = courses.filter(
          item => item.definitionTitle === this.filterCategory
        );
      if (this.filterName !== "")
        courses = courses.filter(item => item.title === this.filterName);
      if (this.filterFreeCourses)
        courses = courses.filter(item => item.workload < item.capacity);

      return courses;
    }
  },
  mounted() {
    const vue = this;
    axios
      .get(process.env.VUE_APP_API_URL + "/public/courses/upcoming")
      .then(response => {
        const courses = [];
        response.data.forEach(item => {
          let dayOfWeeks = [];
          item.timeslots = {};
          item.times.forEach(day => {
            dayOfWeeks.push(day.weekday);
            item.timeslots[day.weekday] = day.time;
          });
          item.dayOfWeeks = dayOfWeeks;
          if (item.type === "club") {
            const now = new Date();
            const nextMonth = new Date(
              now.getFullYear(),
              now.getMonth() + 1,
              1
            );
            const startDate = new Date(item.startDate);
            if (startDate < nextMonth) item.startDate = nextMonth;
          }
          courses.push(item);

          if (vue.categories.indexOf(item.definitionTitle) === -1) {
            vue.categories.push(item.definitionTitle);
          }
          if (vue.baths.indexOf(item.location) === -1) {
            vue.baths.push(item.location);
          }
        });

        vue.baths.sort();
        vue.categories.sort();
        vue.course = courses;

        if (vue.$route.params.filterCategory !== undefined) {
          vue.filterCategory = vue.$route.params.filterCategory;
        }
        if (vue.$route.params.filterName !== undefined) {
          vue.filterName = vue.$route.params.filterName;
        }
      });
  },
  watch: {
    filteredCourses: function() {
      if (this.currentPage > this.maxPages) this.changePage(1);
    },
    filterCategory: function(value) {
      if (value !== this.$route.params.filterCategory) this.filterName = "";
    }
  },
  created() {
    if (this.axios.defaults.headers["X-LOCATION"] === undefined) {
      this.$router.push({ name: "start" });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
